import SurveyLayout from '../../Layout/SurveyLayout';
import NpsStoreSurveyForm from '../../NpsStoreSurveyForm';

const NpsStore = () => {
  return (
    <SurveyLayout>
      <NpsStoreSurveyForm />
    </SurveyLayout>
  );  
};
export default NpsStore;
